import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PriceLimits } from '@model';
import { ResourceService } from './resource.service';

@Injectable()
export class PriceLimitsService {
  private priceLimits$: Observable<PriceLimits>;

  apiUrl: string;

  constructor(private priceLimitsService: ResourceService<PriceLimits>) {
    this.apiUrl = priceLimitsService.apiLocation;
  }

  getPriceLimits(): Observable<PriceLimits> {
    this.priceLimits$ = this.priceLimitsService.get(`price-limits`);

    return this.priceLimits$;
  }
}
